import {
  SlSkeleton
} from "./chunk.F4NP2SRV.js";

// src/components/skeleton/skeleton.ts
var skeleton_default = SlSkeleton;
SlSkeleton.define("sl-skeleton");

export {
  skeleton_default
};
